import { render, staticRenderFns } from "./CorrespondenceAddress.vue?vue&type=template&id=1a64e4a0&scoped=true"
import script from "./CorrespondenceAddress.vue?vue&type=script&lang=js"
export * from "./CorrespondenceAddress.vue?vue&type=script&lang=js"
import style0 from "./CorrespondenceAddress.vue?vue&type=style&index=0&id=1a64e4a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a64e4a0",
  null
  
)

export default component.exports